module.exports = __webpack_public_path__ + "static/assets/fe4863d532234f0e9e15a3b51bb603eb.png";